import { Outlet } from "react-router-dom";
import React, { useEffect } from 'react';
import Header from "./Header";
import Footer from "./Footer";

// import { Helmet } from 'react-helmet';

function Layout() {
    useEffect(() => {          
      }, []);
    
    return(
        <>    
            <Header />
            <Outlet />
            <Footer />
        </>
    )    
}

export default Layout;